import styled from 'styled-components';
import { Button } from 'antd';

const Container = styled.div`
  width: 100%;
  position: relative;
  height: 50px;
  .anticon {
    color: #fff;
  }
`;

export default props => {
  const { canEdit } = nx.$root.content;
  return (
    <Container data-disabled={!canEdit}>
      <View o={6} as={Button} asProps={{ size: 'small' }} plugin="transform-center:xy">
        上传srt
      </View>
    </Container>
  );
};
